@if (showStaticLabelRow()) {
  <div class="field-label-row">
    @if (!isFloating() && label()) {
      <span class="field-label" [attr.for]="inputId()">
        {{ label() }}

        @if (required()) {
          <span class="field-required">*</span>
        }
      </span>
    } @else {
      <span class="field-label-spacer" aria-hidden="true"></span>
    }

    @if (effectiveHint()) {
      <span class="field-hint">{{ effectiveHint() }}</span>
    }
  </div>
}

<div class="field-control">
  <textarea
    #textareaEl
    class="field-textarea"
    [id]="inputId()"
    [placeholder]="effectivePlaceholder()"
    [disabled]="disabled()"
    [rows]="rows()"
    [attr.maxlength]="maxLength()"
    [attr.aria-label]="isFloating() ? label() : null"
    [ngModel]="value()"
    (ngModelChange)="onModelChange($event)"
    [ngModelOptions]="{ standalone: true }"
    (focus)="onFocus()"
    (blur)="onBlur()"
  ></textarea>

  @if (isFloating() && label()) {
    <span
      class="field-floating-label"
      [attr.for]="inputId() || null"
      (click)="focus()"
    >
      {{ label() }}
      @if (required()) {
        <span class="field-required">*</span>
      }
    </span>
  }
</div>

@if (displayMessage()) {
  <span class="field-message" [class.field-message-error]="hasError()">
    @if (hasError()) {
      <i
        class="fa-sharp fa-light fa-circle-exclamation"
        style="position: relative; top: -1px;"
        aria-hidden="true"
      ></i>
    }

    {{ displayMessage() }}
  </span>
}
